import React from 'react';
import './../styles/header.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Header() {
  const location = useLocation();
  const [activeSubLink, setActiveSubLink] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const links = [
    { id: 0, path: "/", text: "首页" },
    { id: 1, path: "/CompanyProfile", text: "公司简介" },
    {
      id: 2,
      path: "/service/digitaltwin",
      text: "服务能力",
      subLinks: [
        { id: 3, path: "/service/digitaltwin", text: "数字孪生" },
        { id: 4, path: "/service/smartParking", text: "智慧停车" },
        { id: 5, path: "/service/cloudChain", text: "智盾云链" },
        { id: 6, path: "/service/addressManagement", text: "地址治理" },
        { id: 7, path: "/service/GIS-servicePlatform", text: "GIS服务平台" },
      ],
    },
    { id: 8, path: "/Notice", text: "采购公告" },
    { id: 9, path: "/Join", text: "加入我们" },
    { id: 10, path: "/News", text: "新闻资讯" },
  ];

  const handleMouseEnter = (index) => {
    setActiveSubLink(index);
  };

  const handleMouseLeave = () => {
    setActiveSubLink(null);
  };

  useEffect(() => {
    const handleScroll = () => {
      const headerHomeTemp = document.querySelector(".header-home-temp");
      if (window.scrollY > 0) {
        headerHomeTemp.style.backgroundColor = "rgba(255, 255, 255, 1)";
      } else {
        headerHomeTemp.style.backgroundColor = "transparent";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={location.pathname !== "/" ? "header" : "header-home"}>
      <div className="header-home-temp">
        <div className="ctas">
          <img src="/assets/logo.png" alt="云网数智" />
        </div>
        <nav className="nav-links">
          {links.map((link) => (
            <div
              key={link.id}
              className="nav-item"
              onMouseEnter={() => handleMouseEnter(link.id)}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                to={link.path} 
                className={`nav-link ${
                  location.pathname === link.path ||
                  (link.subLinks &&
                    link.subLinks.some((subLink) => location.pathname === subLink.path))
                    ? "nav-link-active"
                    : ""
                }`}
              >
                {link.text}
              </Link>
              {link.subLinks && (
                <ul
                  className={`sub-links ${activeSubLink === link.id ? "show" : ""}`}
                >
                  {link.subLinks.map((subLink) => (
                    <li key={subLink.id}>
                      <Link
                        to={subLink.path}  
                        className={`${location.pathname === subLink.path ? "sub-link-active" : "sub-link"}`}
                      >
                        {subLink.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </nav>
      </div>
    </header>
  );
}